export const STUDENT_COURSES_REQUEST = 'STUDENT_COURSES_REQUEST'
export const STUDENT_COURSES_RESPONSE = 'STUDENT_COURSES_RESPONSE'
export const STUDENT_PROFILE_REQUEST = 'STUDENT_PROFILE_REQUEST'
export const STUDENT_PROFILE_RESPONSE = 'STUDENT_PROFILE_RESPONSE'
export const STUDENT_PROFILE_CREATE = 'STUDENT_PROFILE_CREATE'
export const STUDENT_PROFILE_EDIT = 'STUDENT_PROFILE_EDIT'

const reducer = (state = {}, action) => {
  switch (action.type) {
    case STUDENT_PROFILE_RESPONSE:
      return {
        ...state,
        profile: action.data,
      }
    case STUDENT_COURSES_RESPONSE:
      return {
        ...state,
        courses: action.data,
      }
    default:
      return state
  }
}

export const coursesRequest = () => {
  return {
    type: STUDENT_COURSES_REQUEST,
  }
}

export const profileRequest = () => {
  return {
    type: STUDENT_PROFILE_REQUEST,
  }
}

export const profileCreate = data => {
  return {
    type: STUDENT_PROFILE_CREATE,
    data: data,
  }
}

export const profileEdit = data => {
  return {
    type: STUDENT_PROFILE_EDIT,
    data: data,
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/studentsReducer.js